import { render } from "./AnalizaOrganizacionogModela.vue?vue&type=template&id=7567feaa&scoped=true&lang=html"
import script from "./AnalizaOrganizacionogModela.vue?vue&type=script&lang=js"
export * from "./AnalizaOrganizacionogModela.vue?vue&type=script&lang=js"

import "./AnalizaOrganizacionogModela.vue?vue&type=style&index=0&id=7567feaa&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-7567feaa"

export default script